module.exports = __webpack_public_path__ + "static/blog-overview-94888b846c36864665db28bf4e7800ac.jpg";